/**
 * useNotchesScorecard — shared data hook across all scorecard pages
 * (overview, 4 per-model pages, full log). Module-level 5-min cache so
 * navigating between pages is instant, not a re-fetch.
 *
 * The Lambda itself caches for 10 min, so worst case a page ~5 min stale
 * from module cache falls through to a Lambda cache-hit anyway.
 */

import { useEffect, useState } from 'react';
import { fetchNotchesScorecard, ScorecardPayload } from './notchesScorecardService';

let cachedData: ScorecardPayload | null = null;
let cachedAt = 0;
const CACHE_MS = 5 * 60 * 1000;

export function useNotchesScorecard() {
  const [data, setData] = useState<ScorecardPayload | null>(
    cachedData && Date.now() - cachedAt < CACHE_MS ? cachedData : null
  );
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (cachedData && Date.now() - cachedAt < CACHE_MS) return;
    let cancelled = false;
    fetchNotchesScorecard()
      .then((d) => {
        if (cancelled) return;
        cachedData = d;
        cachedAt = Date.now();
        setData(d);
      })
      .catch((e) => { if (!cancelled) setErr(String(e?.message || e)); });
    return () => { cancelled = true; };
  }, []);

  return { data, err };
}
